// extracted by mini-css-extract-plugin
export default {"mark":"mark---bc93p"};